import { ref } from 'vue'

import { serializePaymentForm } from '@/lib/adapters/payments.adapter'
import { handleErrorMessage } from '@/lib/helpers/error.helpers'
import { request } from '@/lib/services'
import type { PaymentFormType } from '@/lib/types/payments.types'
import { useErrorStore } from '@/stores/error'

export const useDeleteAdditionalPaymentRequest = () => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)

  const errorStore = useErrorStore()

  const deletePayment = async (id: number) => {
    try {
      isLoading.value = true
      error.value = null
      await request.delete(`/admin/one-time-earnings/${id}`)
    } catch (e) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }

  return {
    deletePayment,
    isLoading,
    error,
  }
}

export const useAddAdditionalPaymentRequest = () => {
  const isLoading = ref(false)
  const error = ref<Error | null>(null)

  const errorStore = useErrorStore()

  const addPayment = async (paymentDate: PaymentFormType, advertiserId: number) => {
    try {
      const data = serializePaymentForm(paymentDate, advertiserId)
      isLoading.value = true
      error.value = null
      await request.post('/admin/one-time-earnings', data)
    } catch (e) {
      errorStore.setError(handleErrorMessage(e))
      error.value = e as Error
    } finally {
      isLoading.value = false
    }
  }

  return {
    addPayment,
    isLoading,
    error,
  }
}
